import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Regulation } from '../../Regulation'
import {
  REGULATION_TYPE_CAMPAIGN,
  REGULATION_TYPE_CAMPAIGN_AND_VENDOR,
  REGULATION_TYPE_VENDOR
} from '../constants'
import { Button } from 'loyal-react'
import Modal from 'react-awesome-modal'

const ModalTerms = props => (
  <Modal width='1180' height='502' effect='fadeInUp' visible={props.show}>
    <Fragment>
      <div
        className={`col-12 border-bottom-lg border-color-featured bg-white py-3 mr-auto ml-auto`}
      >
        <div className='row px-3'>
          <div className='col'>
            <h2 className='txt-font-title'>Termos do regulamento</h2>
          </div>
          <div className='col-auto'>
            <Button
              name={'Close'}
              className='btn btn-double btn-flat btn-icon-only btn-icon mx-0'
              iconName='icon_close icon-sm'
              text=''
              aria-label='Fechar'
              onClick={e => props.onClose()}
            />
          </div>
        </div>
        <div className='col-12'>
          <div className='row px-3'>
            <div className='col mx-0 mt-2 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3'>
              <div className='row mr-1'>
                <div className='col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm'>
                  {CheckTypeHandler(props.terms)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 pt-3'>
          <div className='row align-items-center h-100 px-3'>
            <div className='modal-back col-2 px-0 txt-left mr-auto' />
            <div className='modal-back col-4 px-0 txt-right'>
              <Button
                id={'Agree-recharge'}
                name={'Agree'}
                className='btn btn-double btn-featured btn-icon mx-0'
                iconName='icon_check_circle'
                text='LI E ACEITO O REGULAMENTO'
                onClick={e => props.acceptTerms()}
                loading={!!props.btnAgreeIsLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  </Modal>
)

const CheckTypeHandler = terms => {
  switch (terms.type) {
    case REGULATION_TYPE_CAMPAIGN:
      return <Regulation />

    case REGULATION_TYPE_CAMPAIGN_AND_VENDOR:
      return (
        <Regulation
          vendorId={terms.vendorId}
          regulationType={terms.regulationType}
        />
      )

    case REGULATION_TYPE_VENDOR:
      return <Regulation vendorId={terms.vendorId} />
  }
}

ModalTerms.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  acceptTerms: PropTypes.func,
  terms: PropTypes.object,
  btnAgreeIsLoading: PropTypes.bool
}

export default ModalTerms



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/ModalTerms/ModalTerms.js